<div fxLayout>
  <main fxFlex [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <!-- header-->
    <div fxLayout id="smartlocks_header">
      <h2 fxFlex fxLayout fxLayoutAlign="start center" fxLayoutGap="10px">
        <img class="clickable" [routerLink]="['../']" src="/assets/iconography/arrow-left-rose.svg" />
        <img
          fxHide.lt-md
          fxFlex="0 0 36px"
          height="36px"
          src="/assets/images/apps/integrations/schlage.svg"
          *ngIf="integration === 'Schlage'" />
        <img
          fxHide.lt-md
          fxFlex="0 0 36px"
          height="36px"
          src="/assets/images/apps/integrations/remote-lock.svg"
          *ngIf="integration === 'RemoteLock'" />
        <img
          fxHide.lt-md
          fxFlex="0 0 36px"
          height="36px"
          src="/assets/images/apps/integrations/august-lock.svg"
          *ngIf="integration === 'August'" />
        <img
          fxHide.lt-md
          fxFlex="0 0 36px"
          height="36px"
          src="/assets/images/apps/integrations/yale.svg"
          *ngIf="integration === 'Yale'" />
        <img
          fxHide.lt-md
          fxFlex="0 0 36px"
          height="36px"
          src="/assets/images/apps/integrations/smartthings.svg"
          *ngIf="integration === 'SmartThings'" />
        <img
          fxHide.lt-md
          fxFlex="0 0 36px"
          height="36px"
          src="/assets/images/apps/integrations/nuki.svg"
          *ngIf="integration === 'Nuki'" />
        <img
          fxHide.lt-md
          fxFlex="0 0 36px"
          height="36px"
          src="/assets/images/apps/integrations/igloohome.svg"
          *ngIf="integration === 'IglooHome'" />
        <img
          fxHide.lt-md
          fxFlex="0 0 36px"
          height="36px"
          src="/assets/images/apps/integrations/ttlock-circle.svg"
          *ngIf="integration === 'TTLock'" />
        <span fxFlex>{{ integration }}</span>
      </h2>

      <sbnb-save-indicator id="save-indicator" [saveStatus]="saveStatus"></sbnb-save-indicator>
    </div>
    <sbnb-helptext-wrapper
      *ngIf="pageIdentifier"
      class="helptext-wrapper-type-content"
      [area]="'content'"
      [pageId]="pageIdentifier"></sbnb-helptext-wrapper>

    <div id="smartlocks_main" fxLayout fxLayout.lt-lg="column" fxLayoutGap="40px" fxLayoutGap.lt-lg="40px">
      <div id="smartlocks_detail" fxFlex>
        <!-- Step 1 - connecting smartlock accounts-->
        <section class="smartlocks-section">
          <h3>1. Connect your {{ integration }} accounts</h3>
          <div class="smartlocks_intro_text">
            Connect your {{ integration }} account to import the list of your locks and match them with properties on
            {{ 'CORE.PRODUCT_NAME' | transloco }}.
          </div>
          <div class="connect__button">
            <sbnb-button
              *ngIf="linkedLocks?.length === 0 && otherLocks.length === 0; else alreadyConnectedButton"
              id="smartlocks_connect_button"
              label="Connect with {{ integration }}"
              [loading]="loading"
              (click)="openConnectDialog()"></sbnb-button>

            <ng-template #alreadyConnectedButton>
              <div fxLayout fxLayoutGap="12px" *ngIf="!accountDisconnected">
                <sbnb-button
                  id="smartlocks_connect_button-alreadyconnected"
                  label="{{ integration }} account connected"
                  type="text"
                  icon="check"
                  [disabled]="true"></sbnb-button>

                <sbnb-button type="secondary" (click)="openConnectDialog()">
                  Connect another {{ integration }} account
                </sbnb-button>
              </div>

              <div fxLayout fxLayoutGap="12px" *ngIf="accountDisconnected === true">
                <sbnb-button
                  id="smartlocks_connect_button-disconnected"
                  label="{{ integration }} account disconnected"
                  type="text"
                  icon="delete"
                  [disabled]="true"></sbnb-button>

                <sbnb-button type="secondary" (click)="openConnectDialog(true)">
                  Reconnect your {{ integration }} account
                </sbnb-button>
              </div>
            </ng-template>
          </div>

          <div class="dashboard__tab-innner" *ngIf="smartlockAccounts.length > 0">
            <div fxLayout fxLayoutGap="18px" fxHide.lt-md class="lock-header">
              <div fxFlex>Account</div>
              <div fxFlex>Status</div>
            </div>

            <div
              *ngFor="let account of smartlockAccounts; let i = index"
              fxLayout
              fxLayoutAlign="start center"
              fxLayoutGap="18px"
              class="lock-row">
              <div fxFlex fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
                <div fxLayout="column" fxLayoutGap="6px">
                  <strong>{{ account.email }}</strong>
                </div>
              </div>

              <div fxFlex fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
                <div fxLayout="column" fxLayoutGap="6px">
                  <strong>{{ account.disconnected ? 'Disconnected' : 'Connected' }}</strong>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- Step 2 - matching locks to properties -->
        <section class="smartlocks-section">
          <h3>2. Match locks to properties</h3>
          <div class="smartlocks_intro_text">
            Match your
            <span *ngIf="integration === 'Schlage'">Schlage</span>
            <span *ngIf="integration === 'RemoteLock'">August, Yale or RemoteLock</span>
            <span *ngIf="integration === 'August'">August</span>
            <span *ngIf="integration === 'Yale'">Yale</span>
            <span *ngIf="integration === 'SmartThings'">SmartThings</span>
            <span *ngIf="integration === 'Nuki'">Nuki</span>
            <span *ngIf="integration === 'IglooHome'">IglooHome</span>
            <span *ngIf="integration === 'TTLock'">TTLock</span>
            smart locks through your {{ integration }} account to {{ 'CORE.PRODUCT_NAME' | transloco }} properties to
            connect them together. You can associate multiple locks to a single property. If you add new locks to your
            {{ integration }} account, no further action is needed; new locks should sync automatically within 24 hours.
          </div>

          <mat-tab-group>
            <mat-tab [label]="(isMobile$ | async) ? 'Matched locks' : 'Locks matched with a property'">
              <div *ngIf="loadingLinkedLocks" class="margin-20">
                <mat-spinner diameter="30"></mat-spinner>
              </div>

              <div *ngIf="!loadingLinkedLocks && (!linkedLocks || linkedLocks?.length === 0)" class="margin-20">
                <sbnb-no-items icon="lock" text="You don't have any matched locks at the moment"></sbnb-no-items>
              </div>

              <div class="dashboard__tab-innner" *ngIf="linkedLocks && linkedLocks.length > 0">
                <div fxLayout fxLayoutGap="18px" fxHide.lt-md class="lock-header">
                  <div fxFlex>Lock name</div>
                  <div fxFlex="120px">Properties</div>
                  <div fxFlex="144px" fxLayoutAlign="start center" fxLayoutGap="4px">
                    <span>Actions</span>
                    <a
                      class="clickable"
                      href="https://my.hospitable.com/support-documentation/article/5757397-how-to-connect-my-smart-lock#h_2fe04d83cd"
                      target="_blank">
                      <img width="14px" height="14px" src="/assets/iconography/question-active.svg" />
                    </a>
                  </div>
                </div>

                <div
                  *ngFor="let linkedLock of linkedLocks; let i = index"
                  fxLayout
                  fxLayoutAlign="start center"
                  fxLayoutGap="18px"
                  class="lock-row">
                  <div fxLayout.lt-md="column" fxFlex fxLayoutGap="8px">
                    <strong *ngIf="linkedLock.additional_info?.display_name">
                      {{ linkedLock.additional_info.display_name }}
                    </strong>
                    <strong
                      *ngIf="
                        !linkedLock.additional_info?.display_name && !linkedLock.additional_info?.lock_disconnected
                      ">
                      Matched lock {{ i + 1 }}
                    </strong>
                    <div>
                      <span
                        *ngIf="
                          linkedLock.additional_info?.lock_disconnected ||
                          linkedLock.additional_info?.errors?.length > 0
                        "
                        class="badge badge-lemon">
                        Lock disconnected
                      </span>
                    </div>
                    <sbnb-cs-debug-item
                      label="lock_id"
                      [value]="linkedLock.lock_id"
                      style="font-size: 10px"></sbnb-cs-debug-item>
                    <sbnb-cs-debug-item
                      *ngIf="integration !== 'RemoteLock'"
                      label="seam_uuid"
                      [value]="linkedLock.additional_info?.serial_number"
                      style="font-size: 10px"></sbnb-cs-debug-item>
                  </div>

                  <div fxFlex="120px" fxFlex.lt-md="0 0 auto" fxLayoutAlign="start center">
                    <sbnb-avatar-group
                      [items]="linkedLock.property_list"
                      [itemsForLabel]="linkedLock.additional_info?.display_name || 'Smart lock'"></sbnb-avatar-group>
                  </div>

                  <div
                    fxFlex="144px"
                    fxFlex.lt-md="0 0 auto"
                    fxLayout
                    fxLayout.lt-md="column"
                    fxLayoutAlign.lt-md="end end"
                    fxLayoutGap="8px">
                    <sbnb-button
                      [loading]="linkedLock.resyncing"
                      label="Resync"
                      size="mini"
                      type="secondary"
                      (click)="resyncLock(linkedLock)"></sbnb-button>

                    <sbnb-button label="Edit" size="mini" type="secondary" (click)="editLock(linkedLock)"></sbnb-button>
                  </div>

                  <!-- <mat-menu #actionsMenu="matMenu">
                    <button mat-menu-item (click)="resyncLock(linkedLock)">
                    <span>
                      <mat-icon inline="true">event_note</mat-icon>
                      <span>Resync</span>
                    </span>
                  </button>
                    <button mat-menu-item (click)="editLock(linkedLock)">
                      <span>
                        <mat-icon inline="true">event_note</mat-icon>
                        <span>Edit</span>
                      </span>
                    </button>
                  </mat-menu> -->
                </div>
              </div>
            </mat-tab>

            <mat-tab label="Unmatched locks">
              <div *ngIf="loadingOtherLocks" class="margin-20">
                <mat-spinner diameter="30"></mat-spinner>
              </div>

              <div *ngIf="!loadingOtherLocks && (!otherLocks || otherLocks?.length === 0)" class="margin-20">
                <sbnb-no-items icon="lock" text="You don't have any unmatched locks at the moment"></sbnb-no-items>
              </div>

              <div class="dashboard__tab-innner" *ngIf="otherLocks && otherLocks.length > 0">
                <div fxLayout fxLayoutGap="18px" fxHide.lt-md class="lock-header">
                  <div fxFlex>Lock name</div>
                  <div fxFlex *ngIf="integration == 'RemoteLock'">Lock serial number</div>
                  <div fxFlex="40px">Actions</div>
                </div>
              </div>
              <sbnb-unmatched-lock
                *ngFor="let otherLock of otherLocks; let i = index"
                [lock]="otherLock"
                (editLock)="editLock($event)"></sbnb-unmatched-lock>
            </mat-tab>
          </mat-tab-group>
        </section>

        <!-- Step 3 - Settings -->
        <section class="smartlocks-section">
          <h3>3. Review Smartlock settings</h3>
          <div class="smartlocks_intro_text">
            (Optional) Review and update your smart lock settings. These settings are shared with Devices settings.
          </div>

          <div style="margin-top: 24px">
            <app-settings-smartlocks
              *ngIf="integration === 'RemoteLock'"
              [showNotifications]="integration == !'RemoteLock'"></app-settings-smartlocks>
          </div>
        </section>

        <!-- Step 4 - Short code -->
        <section class="smartlocks-section">
          <h3>4. Adding short code to messages</h3>
          <div class="smartlocks_intro_text">
            Before we can automatically send the generated PIN codes to guests, you'll need to add the
            <strong class="raspberry">%smartlock_code%</strong>
            short code to scheduled messages or new reservation messages in Guest Experience.
          </div>

          <div style="margin-top: 24px">
            <sbnb-button
              type="secondary"
              label="Go to Guest Experience"
              [routerLink]="['/gx/rules/segments/47dd6325-87dc-48e1-bebd-e68f532410ca']"></sbnb-button>
          </div>
        </section>
      </div>
    </div>
  </main>
</div>
